import ObjectChecker from "@/utils/common/ObjectChecker.ts";

export default class CollectionUtils
{
  static addListIfNotFound(targetList: any[], toAdd: any[] | null | undefined) {
    if (!toAdd || !toAdd.length)
      return;
    for (let object of toAdd) {
      this.addIfNotFound(targetList, object);
    }
  }

  static addIfNotFound(targetList: any[], object: any) {
    if (!targetList.contains(object))
      targetList.push(object);
  }

  static getOrAdd(key: string, map: Record<string, any[]>) {
    let list = map[key];
    if (!list)
      map[key] = list = [];
    return list;
  }

  static fillWithLastElement(list: any[], newSize: number) {
    while (list.length < newSize) {
      list.push(list[list.length - 1])
    }
  }

  static sortAndRemoveDuplicates(list: any[], comparator: (a: any, b: any) => number) {
    list.sort(comparator);
    for (let i = list.length - 1; i > 0; i--) {
      if (ObjectChecker.areEqual(list[i], list[i - 1])) {
        list.splice(i, 1);
      }
    }
  }

}
